// Bare import; a webpack alias redirects `transliteration` to its browser ESM
// bundle so no Node-only code leaks into the client bundle. See
// `.config/webpack.config.js` (`resolve.alias`).
import { transliterate } from 'transliteration';
import getSlug from 'speakingurl';

// Fall back to Unicode transliteration only when speakingurl produces an empty
// slug (e.g. Hangul, Kana and other scripts it does not map).
export const slugify = (input: string | null | undefined): string => {
  const value = input || '';
  return getSlug(value) || getSlug(transliterate(value));
};
